import { render, staticRenderFns } from "./PatientMonitoringDataForm.vue?vue&type=template&id=537b0b2b&"
import script from "./PatientMonitoringDataForm.vue?vue&type=script&lang=js&"
export * from "./PatientMonitoringDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports